export const US_CITIES = [
  { value: 'New York', label: 'New York' },
  { value: 'Los Angeles', label: 'Los Angeles' },
  { value: 'Chicago', label: 'Chicago' },
  { value: 'Houston', label: 'Houston' },
  { value: 'Phoenix', label: 'Phoenix' },
  { value: 'Philadelphia', label: 'Philadelphia' },
  { value: 'San Antonio', label: 'San Antonio' },
  { value: 'San Diego', label: 'San Diego' },
  { value: 'Dallas', label: 'Dallas' },
  { value: 'San Jose', label: 'San Jose' },
  { value: 'Austin', label: 'Austin' },
  { value: 'Jacksonville', label: 'Jacksonville' },
  { value: 'Fort Worth', label: 'Fort Worth' },
  { value: 'Columbus', label: 'Columbus' },
  { value: 'Charlotte', label: 'Charlotte' },
  { value: 'San Francisco', label: 'San Francisco' },
  { value: 'Indianapolis', label: 'Indianapolis' },
  { value: 'Seattle', label: 'Seattle' },
  { value: 'Denver', label: 'Denver' },
  { value: 'Washington', label: 'Washington' },
  { value: 'Boston', label: 'Boston' },
  { value: 'El Paso', label: 'El Paso' },
  { value: 'Nashville', label: 'Nashville' },
  { value: 'Detroit', label: 'Detroit' },
  { value: 'Oklahoma City', label: 'Oklahoma City' },
  { value: 'Portland', label: 'Portland' },
  { value: 'Las Vegas', label: 'Las Vegas' },
  { value: 'Memphis', label: 'Memphis' },
  { value: 'Louisville', label: 'Louisville' },
  { value: 'Baltimore', label: 'Baltimore' },
  { value: 'Milwaukee', label: 'Milwaukee' },
  { value: 'Albuquerque', label: 'Albuquerque' },
  { value: 'Tucson', label: 'Tucson' },
  { value: 'Fresno', label: 'Fresno' },
  { value: 'Sacramento', label: 'Sacramento' },
  { value: 'Kansas City', label: 'Kansas City' },
  { value: 'Mesa', label: 'Mesa' },
  { value: 'Atlanta', label: 'Atlanta' },
  { value: 'Omaha', label: 'Omaha' },
  { value: 'Murfreesboro', label: 'Murfreesboro' },
  // ...add more as needed
];

export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]; 